import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Circle
} from "react-google-maps";

const ZoningMap = (props) => {
  const {
    radius,
    latitude,
    longitude,
    color,
    places,
    onChange
  } = props;

  const onClick = (e) => {
    onChange([{
      key: "latitude",
      value: e.latLng.lat()
    }, {
      key: "longitude",
      value: e.latLng.lng()
    }]);
  };

  return (
    <GoogleMap
      defaultZoom={12}
      defaultCenter={{
        lat: 40.15,
        lng: 44.51
      }}
      onClick={onClick}
    >
      {places.map(place => (
        <Fragment key={place.id}>
          <Marker position={{
            lat: parseFloat(place.latitude),
            lng: parseFloat(place.longitude)
          }}/>
          {place.circle && (
            <Circle
              defaultCenter={{
                lat: parseFloat(place.latitude),
                lng: parseFloat(place.longitude)
              }}
              radius={place.circle.radius}
              options={place.circle.options}
            />
          )}
        </Fragment>
      ))}

      {longitude && latitude ?
        <Marker position={{
          lng: longitude,
          lat: latitude
        }}/>
        : null}
      {longitude && latitude ?
        <Circle
          radius={radius}
          center={{
            lng: longitude,
            lat: latitude
          }}
          options={{
            strokeColor: color,
            fillColor: color,
            fillOpacity: 0.4,
            strokeWeight: 1,
          }}
          draggable
          onDragEnd={onClick}
        />
        : null}

    </GoogleMap>
  );
};

ZoningMap.propTypes = {
  places: PropTypes.array
};

export default withScriptjs(withGoogleMap(ZoningMap));



// WEBPACK FOOTER //
// ./src/views/pages/zoning/zoning-map.js